/**
 * @generated SignedSource<<94e0f432dab49a5a4e2f604c3decc478>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationFlyerCreateScreenPollFileMutation$variables = {
  url: string;
};
export type IntegrationFlyerCreateScreenPollFileMutation$data = {
  readonly store: {
    readonly createIntegrationPollFile: {
      readonly id: string;
    } | null;
  };
};
export type IntegrationFlyerCreateScreenPollFileMutation = {
  response: IntegrationFlyerCreateScreenPollFileMutation$data;
  variables: IntegrationFlyerCreateScreenPollFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "url",
            "variableName": "url"
          }
        ],
        "concreteType": "IntegrationPollFile",
        "kind": "LinkedField",
        "name": "createIntegrationPollFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationFlyerCreateScreenPollFileMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationFlyerCreateScreenPollFileMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "613923cbf9a68d37e35c23a066079f0f",
    "id": null,
    "metadata": {},
    "name": "IntegrationFlyerCreateScreenPollFileMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationFlyerCreateScreenPollFileMutation(\n  $url: String!\n) {\n  store {\n    createIntegrationPollFile(url: $url) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c59ad9e52a76842deb301af11653b2b";

export default node;
